// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2): MenuPanel shell + MenuPanelItem rows. Deleted with the re-chassis:
// the `margin: '- -Z2'` list pulls (compensated the old hand-rolled
// `padding: 'Z1 A'` body — MenuPanel pads Y and rows run full-width), the
// `':hover': { '& svg': … }` opacity armor (fought the retired
// KeyValueColumnFields/DropdownItem svg games), and the `Line` divider —
// this is a sparse command menu, not dense data, so the body gap + the
// "More canvas modes" caption separate the two groups (§7.7 default).
const Dropdownmoremodesmenu = {
  extends: 'MenuPanel',
  gap: 'A',
  Items: {
    flow: 'y',
    gap: '0',
    childExtends: 'MenuPanelItem',
    childProps: {
      // Active row = the house `selected` wash + medium emphasis (§4.3),
      // replacing DropdownItem's old gray6.15/white active pair; the nested
      // ':hover' keeps the selected fill under the pointer.
      '.isActive': {
        fontWeight: '500',
        background: 'selected',
        ':hover': {
          background: 'selected'
        }
      },
      Icon: {
        order: '-1',
        margin: '- Y1 - -'
      }
    },
    childrenAs: 'props',
    children: (el) => [
      {
        text: '{{ editor.theming.lightMode | polyglot }}',
        isActive: (el) => el.getRootState('sceneTheme') === 'light',
        Icon: {
          theme: 'sepia',
          name: (el, s) => (el.getRootState('sceneTheme') === 'light' ? 'sun' : 'sun outline')
        },
        onClick: (ev, el, s) => {
          const key = 'light'
          el.getRootState().update({
            globalTheme: key,
            sceneTheme: key
          })
          el.getRoot().call('router', window.location.pathname)
          el.getRoot().call('setCookie', 'sceneTheme', key)
          el.getRoot().call('setCookie', 'globalTheme', key)
        }
      },
      {
        text: '{{ editor.theming.darkMode | polyglot }}',
        isActive: (el) => el.getRootState('sceneTheme') === 'dark',
        Icon: {
          theme: 'sepia',
          name: (el, s) => (el.getRootState('sceneTheme') === 'dark' ? 'moon' : 'moon outline')
        },
        onClick: (ev, el, s) => {
          const key = 'dark'
          el.getRootState().update({
            globalTheme: key,
            sceneTheme: key
          })
          el.getRoot().call('router', window.location.pathname)
          el.getRoot().call('setCookie', 'sceneTheme', key)
          el.getRoot().call('setCookie', 'globalTheme', key)
        }
      }
    ]
  },
  More: {
    CaptionTitle: {
      margin: 'X - Y2',
      // Align the caption with MenuPanelItem's Z1 label inset.
      padding: '- Z1',
      Text: {
        text: '{{ editor.mode.moreCanvas | polyglot }}'
      }
    },
    Items: {
      flow: 'y',
      gap: '0',
      childExtends: 'MenuPanelItem',
      childProps: {
        Icon: {
          order: '-1',
          margin: '- Y1 - -'
        }
      },
      childrenAs: 'props',
      children: (el) => [
        {
          text: '{{ editor.mode.code | polyglot }}',
          Icon: {
            name: 'code'
          },
          onClick: (ev, el) => {
            el.call('openRouterModal', '/project-code', {
              animationProps: {
                animation: 'fadeIn'
              }
            })
          }
        },
        {
          text: '{{ editor.mode.preview | polyglot }}',
          Icon: {
            name: 'sf eye'
          },
          Sup: {
            color: 'disabled',
            margin: '-Z - - X2',
            fontSize: 'Y',
            text: '{{ editor.logoMenu.soon | polyglot }}'
          }
        },
        {
          text: '{{ editor.mode.comments | polyglot }}',
          Icon: {
            name: 'chat'
          },
          Sup: {
            color: 'disabled',
            margin: '-Z - - X2',
            fontSize: 'Y',
            text: '{{ editor.logoMenu.soon | polyglot }}'
          }
        }
      ]
    }
  }
}

export { Dropdownmoremodesmenu as 'Dropdown.MoreModesMenu' }
